import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleChevronRight, faCircleChevronLeft, faHouseChimney } from "@fortawesome/free-solid-svg-icons";

import "./Steps.css";

interface RfrPoiScrollerProps {
    name: string,
    className?: string,
    options: Array<string>,
    data: string,
    setData: (name: string, value: Array<string>) => void
}

export default function RfrPoiScroller(props: RfrPoiScrollerProps) {
    const { t } = useTranslation("rfr");
    const [xVal, setXVal] = useState(0);
    const choosen = props.data[props.name];

    const handleChangeOption = (e) => {
        const { name, value, checked } = e.target;
        if (checked && !choosen.includes(value)) {
            props.setData(name, [...choosen, value]);
        }
        if (!checked && choosen.includes(value)) {
            const array = [...choosen]; // make a separate copy of the array
            const index = array.indexOf(value)
            if (index !== -1) {
                array.splice(index, 1);
                props.setData(name, array);
            }
        }
    }

    const move = (e, diff: number) => {
        const button = e.currentTarget;
        const poilist = button.parentElement;
        const proplinecont = poilist.children[1];
        const propline = proplinecont.children[0];
        const proplineWidth = propline.scrollWidth;
        let width = 0;
        if (proplineWidth > propline.clientWidth) {
            width = proplineWidth - 370;
        }

        const leftPos = 0;
        const rightXPos = -width;

        let newXVal = xVal + diff;
        if (newXVal > leftPos || newXVal <= rightXPos) {
            newXVal = 0;
        }
        propline.style.transform = `translate(${newXVal}px)`;
        setXVal(newXVal);
    }

    return (
        <>
            <div className="poi-list">
                {
                    props.options.length > 0 ?
                        (<>
                            <div id="btnLeft" onClick={(e) => move(e, 200)} className="poi-btn">
                                <FontAwesomeIcon icon={faCircleChevronLeft} size="3x" />
                            </div>
                            <div className="property-line-cont">
                                <ul className="property-line">
                                    {
                                        props.options.map((poi, index) => {
                                            return <li className="property-item" key={props.name + "_" + index}>
                                                {/* <object className="property-img" data={google_maps_street_image + "?size=120x80&source=outdoor&radius=30&location=" + poi.address + " Ontario CANADA&key=" + google_maps_key + "&return_error_code=true"} type="image/png"> */}
                                                {/* <img className="property-img" src="images/scroll_house_default.png" alt={poi.address} /> */}
                                                <FontAwesomeIcon icon={faHouseChimney} size="6x" className="property-img" />
                                                {/* </object> */}

                                                <div className="property-desc-div">
                                                    <div className="include-container">
                                                        <input onChange={(e) => handleChangeOption(e)} id={"poi_" + index} type='checkbox' name='pois' checked={choosen.includes(poi.poi_roll_num)} value={poi.poi_roll_num} aria-label={poi.poi_roll_num} />
                                                    </div>
                                                    <div>
                                                        <div className="address">
                                                            {poi.address}
                                                        </div>
                                                        <div className="cva">
                                                            CVA: {poi.cva}
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>
                            <div id="btnRight" className="poi-btn" onClick={(e) => move(e, -200)}>
                                <FontAwesomeIcon icon={faCircleChevronRight} size="3x" />
                            </div>
                        </>
                        )
                        :
                        (
                            <>
                                <div className="poi-error-notice">
                                    {t("rfr.rfrform.step3.nopoi")}
                                </div>
                            </>
                        )
                }
            </div>
            {
                props.options.length > 0 ?
                    (
                        <div className="text-center">
                            {t("rfr.rfrform.step3.fav-note")}
                        </div>
                    )
                    :
                    <></>
            }
        </>
    )
}
